import { arrayOf, shape, string } from "prop-types"
import React from "react"
import Box from "../Box"
import Flex from "../Flex"
import ColorCard from "./ColorCard"

function ColorGrid({ colors }) {
  return (
    <Flex flexWrap="wrap" mx={-4}>
      {colors.map((color, key) => (
        <Box key={key} width={[1 / 2, 1 / 4, 1 / 6, 1 / 6]} p={[2, 2, 2, 4]}>
          <ColorCard
            name={color.name}
            hex={color.prop.hex}
            rgb={color.prop.rgb}
          />
        </Box>
      ))}
    </Flex>
  )
}

ColorGrid.propTypes = {
  colors: arrayOf(
    shape({
      name: string,
    })
  ).isRequired,
}

export default ColorGrid



// WEBPACK FOOTER //
// ./src/components/colorfinder/ColorGrid.js